const ELEMENTS = ".js-accordion .js-accordion-header";
const TOGGLE_CLASS = "is-open";

class Accordion {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS);

    if (!this.elements) {
      return false;
    }

    this.elements.forEach((el) => {
      el.addEventListener("click", this.toggle);
    });
  }

  toggle = (e) => {
    const el = e.currentTarget;
    const target = el.parentNode;

    target.classList.toggle(TOGGLE_CLASS);

    e.preventDefault();
  };
}

new Accordion();

jQuery(document).ready(function ($) {

  function updateSliderBackground() {
    const rangeSlider = $(".range__slider");
    const min = parseInt(rangeSlider.attr("min"));
    const max = parseInt(rangeSlider.attr("max"));
    const value = parseInt(rangeSlider.val());

    const percentage = ((value - min) / (max - min)) * 100;

    rangeSlider.attr("style", `background: linear-gradient(to right, #00A652 ${percentage}%, #E3E3E3 ${percentage}%)`);
  }


  function numberWithCommas(num) {
    return num.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  }

  $(".counter > span").on("click", function () {
    var input = $(".counter input");
    var fixedValue = parseInt(input.val().replace(/\s+/g, ''));
    if ($(this).hasClass("plus")) {
      fixedValue = fixedValue + 10000;
    } else if ($(this).hasClass("minus")) {
      fixedValue = fixedValue - 10000;
    }
    if ((fixedValue <= 1000) || (isNaN(fixedValue))) {
      fixedValue = 1000;
    } else if (fixedValue >= 5000000) {
      fixedValue = 5000000;
    }
    input.val(numberWithCommas(fixedValue) + " Kč");
    $(".range__slider").val(fixedValue);
    updateSliderBackground();
  });

  $(".counter input").on("change blur", function () {
    var fixedValue = parseInt($(this).val().replace(/\s+/g, ''));
    if ((fixedValue <= 1000) || (isNaN(fixedValue))) {
      fixedValue = 1000;
    } else if (fixedValue >= 5000000) {
      fixedValue = 5000000;
    }
    $(this).val(numberWithCommas(fixedValue) + " Kč");
    $(".range__slider").val(fixedValue);
    updateSliderBackground();
  });

  $(".range__slider").on("change input", function () {
    var input = $(".counter input");
    var value = $(this).val();
    input.val(numberWithCommas(value) + " Kč");
    updateSliderBackground();
  });

  var loanRequestForm = $("#loanRequestForm");

    loanRequestForm.on("submit", function () {
        loanRequestForm.find(".error-checkbox[data-type=cf_gdpr_checkbox]").hide();
        loanRequestForm.find(".error-checkbox[data-type=cf_owner_checkbox]").hide();
        loanRequestForm.find(".error-checkbox[data-type=cf_foxentry]").hide();

        if (loanRequestForm.find("input[id=foxentry_validation]").val() !== '1') {
            loanRequestForm.find(".error-checkbox[data-type=cf_foxentry]").fadeIn();
            return false;
        }

        if (!loanRequestForm.find("input[id=cf_gdpr]").is(":checked")) {
            loanRequestForm.find(".error-checkbox[data-type=cf_gdpr_checkbox]").fadeIn();
            return false;
        }

        if (!loanRequestForm.find("input[name=owner]").is(":checked")) {
            loanRequestForm.find(".error-checkbox[data-type=cf_owner_checkbox]").fadeIn();
            return false;
        }

    });

})
